

















































































/* General */
import Vue from 'vue'
import * as routerNames from '@/services/router/router.names'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { IPersonBase } from '@/api/types/response.types'
import { EEntities } from '@/types'
import {
  IMemberDataFromEntityLanding,
  INavMenuGroup,
} from '@/types/data-objects/global'

/* API */

export default Vue.extend({
  name: 'MailboxHomeHeaderOptions',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  props: {
    members: {
      type: Array as () => IPersonBase[],
      required: true,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    accountId: {
      type: Number,
      required: true,
    },

    mailboxId: {
      type: Number,
      required: true,
    },

    mailboxName: {
      type: String,
      default: '',
    },

    totalItemCount: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      EEntities,
      RouteAssistant,
    }
  },

  computed: {
    cachedMemberData(): IMemberDataFromEntityLanding {
      return this.$store.get('app/lastVisitedEntityLandingMemberData')
    },

    hasCachedMemberData(): boolean {
      return (
        this.cachedMemberData &&
        this.cachedMemberData.entityID === this.mailboxId
      )
    },

    menuList(): INavMenuGroup[] {
      const items = [
        {
          label: 'Setup',
          options: [
            {
              value: routerNames.MAILBOX_SETTINGS_AUTO_FORWARDING,
              label: 'Auto-Forwarding',
              icon: 'auto-forwarding',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_OUTGOING_EMAIL,
              label: 'Outgoing Email',
              icon: 'outgoing-email',
            },
          ],
        },
        {
          label: 'Manage',
          options: [
            {
              value: routerNames.MAILBOX_SETTINGS_ASSIGN_PEOPLE,
              label: 'Add/Remove Users',
              icon: 'people',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_CONVERSATION_RULES,
              label: 'Conversation Rules',
              icon: 'incoming-email',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_CHECKLIST_TEMPLATES,
              label: 'Checklist Templates',
              icon: 'everything',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_SAVED_REPLIES,
              label: 'Saved Replies',
              icon: 'saved-replies',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_OFFICE_HOURS,
              label: 'Office Hours',
              icon: 'clock',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_AUTO_RESPONDER,
              label: 'Auto-Responder',
              icon: 'auto-responder',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_EMAIL_SIGNATURE,
              label: 'Email Signature',
              icon: 'edit',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_MANAGE_WORKFLOW,
              label: 'Manage Workflow',
              icon: 'workflows',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_GENERAL_SETTINGS,
              label: 'General Settings',
              icon: 'cog',
            },
            {
              value: routerNames.MAILBOX_SETTINGS_INTEGRATIONS,
              label: 'Integrations',
              icon: 'integrations',
            },
          ],
        },
      ]

      /* Eventually, always add this option to menu and let AO click because the ticket portal page 
         itself will have the <feature-gated-stamp /> applied to it. */
      if (this.$permissions.ticketPortalFeatureEnabled) {
        items.find(i => i.label === 'Setup').options.push({
          value: routerNames.MAILBOX_SETTINGS_TICKET_PORTAL,
          label: 'Ticket Portal',
          icon: 'ticket-portal',
        })
      }
      return items
    },
  },

  watch: {
    members() {
      this.cacheMemberDataFromEntityLanding()
    },
  },

  methods: {
    cacheMemberDataFromEntityLanding() {
      const data = {
        entityID: this.mailboxId,
        members: this.members,
      } as IMemberDataFromEntityLanding

      this.$store.set('app/lastVisitedEntityLandingMemberData', data)
    },
    sendToSettingsLink(value: string) {
      this.$router.push({
        name: value,
        params: {
          accountId: this.$route.params.accountId,
          id: this.$route.params.id,
        },
      })
    },
  },
})
